import { useTranslation } from 'react-i18next';

import { Spinner } from '@/components/atoms/Spinner';
import { PageLayout } from '@/components/Layout';
import { NotFound } from '@/components/molecules/NotFound';
import { useFeatureFlagGate } from '@/hooks/useFeatureFlagGate';

import { AccountConnections } from './AccountConnections';

/**
 * The provider connections that belong to no client, such as the harvest report share. The
 * internal area is OptoScale admins only; the page also waits for the provider-config-ui flag,
 * like the site data sources pages, and is not found without it, as its sidebar link is hidden.
 */
function DataSharesPage() {
    const { t } = useTranslation();
    const gate = useFeatureFlagGate('provider-config-ui');

    if (gate === 'pending') return <Spinner size="lg" />;
    if (gate !== 'enabled') return <NotFound />;

    return (
        <PageLayout title={t('dataShares.title')} subtitle={t('dataShares.description')}>
            <AccountConnections />
        </PageLayout>
    );
}

export default DataSharesPage;
export { DataSharesPage };
